<div class="backup-dialog-container">
  <form>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          {{ 'PAGES.BACKUPS.BACKUP_MODAL.TITLE' | translate }}
        </mat-card-title>
        @if (isExpress$ | async) {
          <div class="express-description">
            {{ 'PAGES.BACKUPS.BACKUP_MODAL.EXPRESS_DESCRIPTION' | translate }}
          </div>
        }
      </mat-card-header>
      <mat-card-content>
        <mat-form-field class="backup-full-width" color="accent">
          <textarea
            matInput
            name="textArea"
            matTextareaAutosize
            matAutosizeMinRows="1"
            matAutosizeMaxRows="4"
            placeholder="{{ 'PAGES.BACKUPS.BACKUP_MODAL.DESCRIPTION' | translate }}"
            [required]="true"
            [(ngModel)]="description"
          ></textarea>
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions layout-align="end right">
        @if (!!showStagingCTA) {
          <button
            type="button"
            mat-raised-button
            color="accent"
            class="backup-action-button"
            [disabled]="disableButton"
            (click)="backupFromProduction()"
            >
            {{ 'PAGES.BACKUPS.BUTTONS.BACKUP_FROM_PRODUCTION' | translate }}
          </button>
          <button
            type="button"
            mat-button
            color="accent"
            class="backup-action-button"
            [disabled]="disableButton"
            (click)="backupFromStaging()"
            >
            {{ 'PAGES.BACKUPS.BUTTONS.BACKUP_FROM_STAGING' | translate }}
          </button>
          <button
            type="button"
            mat-button
            color="accent"
            class="backup-action-button"
            [disabled]="disableButton"
            (click)="closeDialog()"
            >
            @if (!waiting) {
              {{ 'PAGES.BACKUPS.BUTTONS.CANCEL' | translate }}
            } @else {
              <mat-spinner class="info-spinner-small" color="accent" [diameter]="30" [strokeWidth]="4"></mat-spinner>
            }
          </button>
        } @else {
          <button
            type="submit"
            mat-raised-button
            color="accent"
            class="backup-action-button"
            [disabled]="disableButton"
            (click)="confirmDialog()"
            >
            {{ 'PAGES.BACKUPS.BUTTONS.BACKUP_NOW' | translate }}
          </button>
          <button
            type="button"
            mat-button
            color="accent"
            class="backup-action-button"
            [disabled]="disableButton"
            (click)="closeDialog()"
            >
            {{ 'PAGES.BACKUPS.BUTTONS.CANCEL' | translate }}
          </button>
          <mat-spinner
            class="info-spinner-small"
            [style.visibility]="waiting ? 'visible' : 'hidden'"
            color="accent"
            [diameter]="30"
            [strokeWidth]="4"
          ></mat-spinner>
        }
      </mat-card-actions>
    </mat-card>
  </form>
</div>
